import React, { useState, useContext, useEffect } from "react";
import { showInfoToast, showWarningToast } from "../../validation/ToastContainer";
import { getConfirmPopup } from "../../view/popup/PopupContainer";
import { PopupContext } from "../../index";
import { saveRemoteSyslogServerConfig, getRemoteSyslogServerConfig } from "./remoteSyslogServerService";
import SyslogTransportField from "./SyslogTransportField";
import SyslogServerIpField from "./SyslogServerIpField";
import SyslogPortField from "./SyslogPortField";
import EnabledField from "./EnabledField";
import { Save, ChevronDown } from 'lucide-react';

const transports = {
  1: 'udp',
  2: 'tcp'
}

function RemoteSyslogServerSection() {

  const { setPopup } = useContext(PopupContext);
  const [enabled, setEnabled] = useState(false);
  const [ip, setIp] = useState('');
  const [transport, setTransport] = useState('');
  const [port, setPort] = useState('');
  const [collapsed, setCollapsed] = useState(true);

  const onChangeIp = (value) => { setIp(value); };
  const onChangeTransport = (value) => { setTransport(value); };
  const onChangePort = (value) => { setPort(value); };


  const onCheckChangeEnabled = (value) => {
    setEnabled(value);
  }

  const fetchData = async () => {
    try {
      const syslogServer = await getRemoteSyslogServerConfig();
      if (syslogServer) {
        const transporttext = syslogServer.transport;

        let id = null;
        for (const key in transports) {
          if (transports[key] === transporttext) {
            id = key;
            break; // Exit the loop once a match is found
          }
        }

        setIp(syslogServer.ip);
        setTransport(id);
        setPort(syslogServer.port);
        setEnabled(syslogServer.enabled);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSave = () => {

    if (!isValidIP(ip)) {
      showWarningToast('Invalid IP address! Please rectify.', 'Remote Syslog Server');
      return;
    }

    if (!transports[transport]) {
      showWarningToast('Please select Syslog Transport!.', 'Remote Syslog Server');
      return;
    }

    if (port === "") {
      showWarningToast('Invalid Port! Please rectify.', 'Remote Syslog Server');
      return;
    }

    showInfoToast('Setting Remote Syslog Server Ip', 'Remote Syslog Server');

    setPopup(
      getConfirmPopup('Are you sure?',
        'Octopus VAR Remote Syslog Server Ip',
        () => onConfirm()
      )
    );

    const onConfirm = async () => {
      const syslogServer = {
        ip: ip,
        transport: transports[transport],
        port: port,
        enabled: enabled
      }
      saveRemoteSyslogServerConfig(syslogServer);
    };
  }

  const ipAddressRegex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

  const isValidIP = (ip) => {
    return ipAddressRegex.test(ip);
  };


  return (
    <div className="container-fluid">
      <div className="row">
        {/* <div className="col-12 mt-4 mb-4"> */}
        <div className="col-12 mb-4">
          <div className="oct_analysis-card-v2 p-4">
            <button
              className={`oct_settings-section-header`}
              onClick={() => setCollapsed(!collapsed)}
            >
              <h3>Syslog Notifications</h3>
              <ChevronDown
                className={`oct_icon oct_settings-chevron-v2 ${!collapsed ? 'oct_expanded' : ''}`}
              />
            </button>

            <div className={`oct_settings-section-body ${collapsed ? 'oct_collapsed' : 'oct_expanded'}`}>
              <div className="oct_syslog-layout-v2 mt-4">
                {/* Configuration Form - Left Side */}
                <div className="oct_syslog-form-v2">
                  {/* Syslog Client Enabled Checkbox */}
                  <EnabledField value={enabled}
                    onChange={onCheckChangeEnabled} />

                  {/* Input Fields Row */}
                  <div className="oct_syslog-fields-row-v2">
                    <SyslogServerIpField value={ip}
                      onChange={onChangeIp} />

                    <SyslogTransportField transports={transports}
                      value={transport}
                      onChange={onChangeTransport} />
                  </div>

                  {/* PORT - Half width */}
                  <div className="oct_syslog-port-wrapper-v2">
                    <SyslogPortField value={port}
                      onChange={onChangePort} />
                  </div>

                  {/* Save Button */}
                  <div>
                    <button className="oct_btn-export-v2" onClick={onSave}>
                      <Save className="oct_icon" />
                      SAVE REMOTE SYSLOG SERVER CONFIGURATION
                    </button>
                  </div>
                </div>

                {/* Information Panel - Right Side */}
                <div className="oct_syslog-info-panel-v2">
                  <p>
                    <span className="oct_syslog-info-bold-v2">OCTOPUS VAR Application</span> will be considered as Syslog Client.
                    It will send Syslog messages for different events to the configured Syslog Server.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RemoteSyslogServerSection;